import { all, put, takeLatest } from 'redux-saga/effects';
import * as actionTypes from '../actions/actionTypes';
import request, { GET } from '../../services/request';
import { API_URL } from '../../configuration/config';
import { handleError } from './common';
import { success } from '../actions/makeAction';

export function *fetchStatsPool() {
  try {
    const response = yield request(GET, API_URL + 'stats/pool/');
    yield put({
      type: success(actionTypes.FETCH_STATS_POOL),
      payload: response.data,
    });
  } catch (error) {
    yield handleError({ error });
  }
}

export function *fetchStatsUser() {
  try {
    const response = yield request(GET, API_URL + 'stats/user/');
    yield put({
      type: success(actionTypes.FETCH_STATS_USER),
      payload: response.data,
    });
  } catch (error) {
    yield handleError({ error });
  }
}


export function *fetchFoundBlocks() {
  try {
    const response = yield request(GET, API_URL + 'foundblocks/');
    yield put({
      type: success(actionTypes.FETCH_FOUND_BLOCKS),
      payload: response.data,
    });
  } catch (error) {
    yield handleError({ error });
  }
}


export function *fetchMiningWorkers() {
  try {
    const response = yield request(GET, API_URL + 'workers/');
    yield put({type: actionTypes.FETCH_MINING_WORKERS_SUCCESS, payload: response.data});
  } catch (error) {
    yield handleError({error});
    yield put({type: actionTypes.FETCH_MINING_WORKERS_FAILED, error});
  }
}


export function *fetchEarnings(action) {
  try {
    const response = yield request(GET, API_URL + `earnings/${action.payload ? `?scope=${action.payload}` : ''}`);
    yield put({type: actionTypes.FETCH_EARNINGS_SUCCESS, payload: response.data});
  } catch (error) {
    yield handleError({error});
    yield put({type: actionTypes.FETCH_EARNINGS_FAILED, error});
  }
}

export function *fetchStatsLanding() {
  try {
    const response = yield request(GET, API_URL + 'stats/landing/');
    yield put({
      type: success(actionTypes.FETCH_STATS_LANDING),
      payload: response.data,
    });
  } catch (error) {
    yield handleError({ error });
  }
}

export default function *app() {
  yield all([
    yield takeLatest(actionTypes.FETCH_STATS_POOL, fetchStatsPool),
    yield takeLatest(actionTypes.FETCH_STATS_USER, fetchStatsUser),
    yield takeLatest(actionTypes.FETCH_FOUND_BLOCKS, fetchFoundBlocks),
    yield takeLatest(actionTypes.FETCH_MINING_WORKERS, fetchMiningWorkers),
    yield takeLatest(actionTypes.FETCH_EARNINGS, fetchEarnings),
    yield takeLatest(actionTypes.FETCH_STATS_LANDING, fetchStatsLanding),
  ]);
}



// WEBPACK FOOTER //
// /src/redux/saga/app.js